<template>
  <service
    data-aos="fade"
    :image="image"
    :title="title"
  >
    <p>
      Giving you the tools to develop your creativity and confidence, and build trust in
      your senses.
    </p>
    <p>
      From beginners looking to incorporate more nourishing dishes into their diets, to
      experienced creatives wanting to dive deeper into the art of plant-based whole foods
      — cooking classes with Chef Naturelle will leave you with the knowledge of how to
      create dishes that you enjoy!
    </p>
    <p>
      Chef Naturelle classes are designed to supply you with the tools and knowledge to help
      develop your confidence and build trust in your senses, all whilst having fun in the
      kitchen. Classes are created with you in mind: tailored to your needs, dietary preferences
      and personal taste.
    </p>
    <p>
      Available booking options range from private one-on-one sessions to lessons for families
      or friend groups looking to bond through a day of learning and fun in the kitchen! Each
      lesson includes a copy of all recipes used, insider tips and tricks, and guidance on what
      ingredients to use and where to source them.
    </p>
    <p>
      For booking enquiries, or to begin your adventure in discovering your inner chef,
      please contact me at
      <a href="mailto:contact@chefnaturelle.com">contact@chefnaturelle.com</a>.
    </p>
  </service>
</template>

<script>
import MetaInfoBuilder from '@/utils/social'
import Service from '@/components/Service'

export default {
  components: {
    Service,
  },
  data: () => ({
    image: require(`@/assets/images/cooking-classes-banner4.jpg?vuetify-preload`),
    title: 'Cooking Classes',
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description('Whether you would like to incorporate more plant-based dishes into your diet or explore the art of'
        + ' plant-based cooking deeper, you will learn to create food that you enjoy!')
      .image(`${window.location.origin}${this.image.src}`)
      .title(this.title)
      .build()
  }
}
</script>

<style scoped>
</style>
